import React from "react";
import { Card} from "reactstrap";
import styled from "styled-components";
import { PopupButton } from '@typeform/embed-react';

export const CardS = styled(Card)`
border-radius: 20px;
border: 0;
margin-bottom: 2rem;
margin-top: 2rem;
 color:#fff;
 display:flex;
 flex-direction:column;
 align-items:center;
 justify-content:space-between;
 padding: 2rem;
 .card-title{
    font-size:24px;
 }
 @media all and (max-width: 768px) {
    flex-direction:column!important;
    .card-title{
        font-size:18px;
     }
  }
`;


function CardClotereSidebarQuestion() {
    
    return (
        <div className="sticky  transition-all duration-300 z-50 bg-white shadow-sm  top-6  w-full text-center sm:text-left bg-gradient-to-t from-indigo-200 to-indigo-100 rounded-3xl mt-6 p-2">
            <div aria-hidden="true" className="absolute inset-0 hidden overflow-hidden rounded-3xl lg:block">

                <svg
                    fill="none"
                    width={200}
                    height={150}
                    viewBox="0 0 404 384"
                    aria-hidden="true"
                    className="absolute top-full -translate-x-1/3 -translate-y-1/3 transform xl:-translate-y-1/2"
                >
                    <defs>
                        <pattern
                            x={0}
                            y={0}
                            id="64e643ad-2176-4f86-b3d7-f2c5da3b6a6d"
                            width={20}
                            height={20}
                            patternUnits="userSpaceOnUse"
                        >
                            <rect x={0} y={0} fill="currentColor" width={4} height={4} className="text-indigo-500" />
                        </pattern>
                    </defs>
                    <rect fill="url(#64e643ad-2176-4f86-b3d7-f2c5da3b6a6d)" width={404} height={384} />
                </svg>
            </div>
            <div className="relative mx-auto p-4">
              <h4 className="font-bold tracking-tight text-black mb-1">
              Vous avez une question ?
              </h4>
              <p className="text-sm pt-2 sm:block hidden" >
              <b>Posez-la gratuitement à un notaire.</b>      
                Recevez une réponse claire et personnalisée, sans engagement.
              </p>
              <PopupButton
                                        id="cDphxVXu"
                                        size={100}
                                        autoClose={false}
                                        style={{ border: '0' }}
                                        hidden={{ idnotaire: "empty"}}
                                    >
                                        <button className='btn-main no-underline bg-gradient-to-r from-indigo-300 to-indigo-800'>👋 Posez votre question</button>
                                    </PopupButton>
              </div>
            
        </div>
    );
}

export default CardClotereSidebarQuestion;